import { createSlice } from "@reduxjs/toolkit";

const modalsSlice = createSlice({
  name: "modals",
  initialState: [],
  reducers: {
    openModal: (state, action) => {
      const existing = state.find((m) => m.name === action.payload.name);
      if (!existing) {
        state.push({ ...action.payload });
      }
    },
    closeModal: (state, action) => {
      return state.filter((m) => m.name !== action.payload);
    },
  },
});

export const { openModal, closeModal } = modalsSlice.actions;

export const selectModals = (state) => state.modals;

export const selectModal = (name) => (state) =>
  state.modals.find((m) => m.name === name);

export default modalsSlice.reducer;
